module.exports = "<div #baFullCalendar class=\"ba-full-calendar {{baFullCalendarClass || ''}}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baFullCalendar/baFullCalendar.html
// module id = 619
// module chunks = 9